exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sp_label[data-v-bc5d9238]{\n    display: none;\n}\n@media screen and (max-width: 896px) {\n.mypage_mainwindow[data-v-bc5d9238]{\n       width: 98%;\n       margin: 0 auto;\n       -ms-overflow-style: none;\n       scrollbar-width: none;\n}\n.mypage_mainwindow[data-v-bc5d9238]::-webkit-scrollbar {\n        display:none;\n}\n.sp_label[data-v-bc5d9238] {\n        display: inline-block;\n        min-width: 6rem;\n        font-weight: 600;\n}\n.side_display_none[data-v-bc5d9238]{\n        display: none;\n}\n@media screen and (max-width: 650px) {\n.display-table td[data-v-bc5d9238]{\n            font-size: 14px;\n}\n}\n}\n", ""]);

// exports
